import React from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as DefaultSvg } from "../assets/images/Donation_sucess.svg";
import { ReactComponent as SuccessGreenSvg } from "../assets/images/success_green.svg";
import { ReactComponent as SuccessRedSvg } from "../assets/images/success_red.svg";

function BankStatus({ bankKycStatus, onResubmit }) {
  const navigate = useNavigate();

  if (!bankKycStatus) return null;

  const status = bankKycStatus.toUpperCase();

  const config = {
    VERIFIED: {
      title: "Bank Details Verified",
      subtitle: "Status: Verified",
      desc: "Your bank details have been successfully verified by the admin. You can now use all wallet and withdrawal features without any restrictions.",
      color: "#28a745",
    },
    REQUESTED: {
      title: "KYC Request Submitted!",
      subtitle: "Status: Pending Review",
      desc: "Our admin will review your bank details shortly. This usually takes 24–48 hours. You will be notified once the KYC verification is completed.",
      color: "#ff7a00",
    },
    REJECTED: {
      title: "KYC Verification Rejected",
      subtitle: "Status: Rejected",
      desc: "Your bank KYC was rejected by the admin. Please re-submit correct bank details to continue using wallet and withdrawal services.",
      color: "#dc3545",
    },
  };

  const data = config[status] || config.REQUESTED;

  return (
    <div className="col-12 col-md-9 p-0 m-auto">
      <div className="bank_status_container d-flex align-items-center justify-content-center text-center">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="mb-4 d-flex justify-content-center">
                {status === "VERIFIED" && (
                  <SuccessGreenSvg width="120" height="120" />
                )}

                {status === "REJECTED" && (
                  <SuccessRedSvg width="120" height="120" />
                )}

                {status === "REQUESTED" && (
                  <DefaultSvg
                    width="120"
                    height="120"
                    style={{ fill: data.color }}
                  />
                )}
              </div>

              {/* TITLE */}
              <h2 className="fw-bold mb-2" style={{ color: data.color }}>
                {data.title}
              </h2>

              {/* STATUS BADGE */}
              <span
                className="px-3 py-1 rounded-pill d-inline-block mb-3"
                style={{
                  backgroundColor: `${data.color}15`,
                  color: data.color,
                  fontWeight: 500,
                }}
              >
                {data.subtitle}
              </span>

              {/* DESCRIPTION - FULL WIDTH CENTER */}
              <p
                className="text-muted mx-auto mt-3 w-100"
                style={{
                  // maxWidth: "900px",
                  lineHeight: "1.8",
                  fontSize: "16px",
                }}
              >
                {data.desc}
              </p>

              {/* BUTTONS */}
              <div className="mt-4 d-flex justify-content-center gap-3 flex-wrap">
                {/* SHOW ONLY IF REJECTED */}
                {status === "REJECTED" && (
                  <button
                    className="btn btn-danger px-4 py-2 rounded-pill fw-semibold"
                    onClick={onResubmit}
                  >
                    Re-submit Bank Details
                  </button>
                )}

                {/* BACK TO WALLET (Better UX than Feed) */}
                <button
                  className="btn px-4 py-2 rounded-pill fw-semibold"
                  style={{
                    border: "2px solid #ff7a00",
                    color: "#ff7a00",
                    background: "transparent",
                  }}
                  onClick={() => navigate("/wallet")}
                >
                  Back To Wallet
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BankStatus;
